<template>
  <div
    class="upload-new-item-drop-area is-flex is-flex-direction-column-reverse"
    @drop="handleDrop($event)"
    @click="selectFile()"
    :class="{ 'is-loading': isUploadProcessing }"
  >
    <span class="is-size-3">{{
      $t("checkout.upload.chooseDifferent3DFile")
    }}</span>
    <input
      @change="processFile()"
      type="file"
      id="3d-file"
      hidden
      ref="fileInput"
    />
    <p>{{ fileUploadState.message }}</p>
  </div>
</template>

<script>
import { orderProcess } from "../../../store/constants/order-process";
import { eventBus } from "../../../events/event-bus";

export default {
  name: "UploadNewItemDropArea",
  data() {
    return {
      isUploadProcessing: false,
      file: null,
      orderProcess: orderProcess,
      fileUploadState: "",
    };
  },
  computed: {
    currentOrderProcessStep: {
      get() {
        return this.$store.getters["currentOrderProcessStep"];
      },
      set(orderProcessStep) {
        this.$store.dispatch("setCurrentOrderProcessStep", orderProcessStep);
      },
    },
  },
  methods: {
    handleDrop(event) {
      event.preventDefault();
      this.processFile(event.dataTransfer.files[0]);
    },
    processFile(file) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      let vm = this;
      vm.isUploadProcessing = true;
      vm.file = file || this.$refs.fileInput.files[0];

      vm.$store
        .dispatch("upload3DFile", { file: vm.file })
        .then(() => {
          vm.isUploadProcessing = false;
          vm.currentOrderProcessStep = orderProcess.STEPS.CONFIGURE_MODEL;
          vm.$store.dispatch("setCheckoutVisibility", true);
          eventBus.openAnalysisTool("Canvas3D");
        })
        .catch(() => {
          vm.isUploadProcessing = false;
          vm.currentOrderProcessStep = orderProcess.STEPS.NO_ORDER_ONGOING;
        });
    },
    showFileUploadState(message) {
      this.fileUploadState = message;
    },
    selectFile() {
      let clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: false,
        cancelable: false,
      });
      this.$refs.fileInput.dispatchEvent(clickEvent);
    },
  },
  created() {
    let vm = this;
    eventBus.$on("fileUploadStateChanged", (message) => {
      vm.showFileUploadState(message);
    });

    eventBus.$on("fileUploadAborted", () => {
      vm.isUploadProcessing = false;
      vm.fileUploadState = "";
    });
  },
};
</script>

<style scoped lang="scss"></style>
